/**
 * Lightweight cache for equipment images keyed by id or title.
 * Populated by liveMarketplace.ts when listing data is fetched.
 * Read by demoStore.ts PDF builders — avoids circular dependency.
 */

const cache = new Map<string, string>();

const normalizeKey = (key: string) => String(key || "").trim().toLowerCase();

export const setEquipmentImage = (idOrTitle: string, imageUrl: string) => {
  if (idOrTitle && imageUrl) {
    cache.set(normalizeKey(idOrTitle), imageUrl);
  }
};

export const getEquipmentImage = (...keys: string[]): string => {
  for (const key of keys) {
    const hit = cache.get(normalizeKey(key));
    if (hit) return hit;
  }
  return "";
};
